/**
 * cart-praemien-auswahl.js
 *
 * Ermöglicht die Auswahl von Prämien-Ausgaben direkt im Warenkorb.
 * Nutzt für das eigentliche Speichern die zentrale Funktion aus
 * cart-line-sync.js, damit Werte anderer Features (Studentennachweis,
 * Abo-Startmonat) in derselben Zeile nicht überschrieben werden.
 *
 * Sicherheit: Der "Zur Kasse"-Button wird nur deaktiviert (kein Datenverlust,
 * keine Formularmanipulation) solange eine Pflichtauswahl fehlt.
 */

(function () {
  function alleLinienMitPraemienAuswahl() {
    return document.querySelectorAll('.cart-item__praemien-auswahl');
  }

  function checkoutButtonSetzen(disabled) {
    if (window.cartCheckoutGuard) {
      window.cartCheckoutGuard.setBlocker(
        'praemien',
        disabled,
        'Bitte wählen Sie Ihre Prämie(n) aus oder verzichten Sie darauf, um fortzufahren.'
      );
    }
  }

  function statusTextSetzen(container, text) {
    const status = container.querySelector('.cart-item__praemien-status');
    if (status) status.textContent = text;
  }

  function gesamtstatusPruefen() {
    let irgendwasOffen = false;

    alleLinienMitPraemienAuswahl().forEach(function (container) {
      const verzichtCheckbox = container.querySelector('.cart-item__praemien-verzicht-checkbox');
      if (verzichtCheckbox && verzichtCheckbox.checked) {
        statusTextSetzen(container, '');
        return;
      }

      const selects = container.querySelectorAll('.cart-item__praemien-select');
      const alleAusgewaehlt = Array.from(selects).every(function (s) {
        return s.value !== '';
      });

      if (!alleAusgewaehlt) {
        irgendwasOffen = true;
        statusTextSetzen(container, 'Bitte alle Ausgaben wählen oder auf die Prämie verzichten.');
      } else {
        statusTextSetzen(container, '');
      }
    });

    checkoutButtonSetzen(irgendwasOffen);
  }

  function duplikatePruefenUndSperren(container) {
    const selects = Array.from(container.querySelectorAll('.cart-item__praemien-select'));
    const gewaehlteWerte = selects.map(function (s) { return s.value; }).filter(Boolean);

    selects.forEach(function (select) {
      const eigenerWert = select.value;
      Array.from(select.options).forEach(function (option) {
        if (option.value === '') return;
        const istVonAnderemSelectGewaehlt =
          gewaehlteWerte.includes(option.value) && option.value !== eigenerWert;
        option.disabled = istVonAnderemSelectGewaehlt;
      });
    });
  }

  function vollstaendigOderVerzicht(container) {
    const verzichtCheckbox = container.querySelector('.cart-item__praemien-verzicht-checkbox');
    if (verzichtCheckbox && verzichtCheckbox.checked) return true;

    const selects = container.querySelectorAll('.cart-item__praemien-select');
    return Array.from(selects).every(function (s) { return s.value !== ''; });
  }

  function auswahlAendern(container, erzwingen) {
    gesamtstatusPruefen();

    const zeile = container.closest('tr.cart-item');
    if (!zeile) return;

    if (!erzwingen && !vollstaendigOderVerzicht(container)) {
      // Noch nicht vollständig – kein Server-Update, nur Status anzeigen
      return;
    }

    statusTextSetzen(container, 'Aktualisiere Warenkorb…');
    window.cartLineSync.aktualisieren(zeile);
  }

  function init() {
    alleLinienMitPraemienAuswahl().forEach(function (container) {
      duplikatePruefenUndSperren(container);

      // Verhindert doppelt gebundene Listener bei mehrfachem init()
      if (container.dataset.praemienListenerGebunden === 'true') return;
      container.dataset.praemienListenerGebunden = 'true';

      container.querySelectorAll('.cart-item__praemien-select').forEach(function (select) {
        select.addEventListener('change', function (e) {
          // Verhindert, dass das change-Event zum <cart-items> Custom Element
          // hochblubbert – dessen eigener Listener versucht sonst das Event
          // als Mengenänderung zu verarbeiten (fehlendes data-index), was zur
          // generischen Shopify-Fehlermeldung führt.
          e.stopPropagation();
          duplikatePruefenUndSperren(container);
          auswahlAendern(container, false);
        });
      });

      const verzichtCheckbox = container.querySelector('.cart-item__praemien-verzicht-checkbox');
      if (verzichtCheckbox) {
        verzichtCheckbox.addEventListener('change', function (e) {
          e.stopPropagation();
          const selects = container.querySelectorAll('.cart-item__praemien-select');
          selects.forEach(function (s) {
            s.disabled = verzichtCheckbox.checked;
            if (!verzichtCheckbox.checked) s.value = '';
          });
          // erzwingen: true – auch bei unvollständiger Auswahl sofort
          // synchronisieren, damit keine veraltete Verzicht-Eigenschaft
          // unbemerkt im Warenkorb stehen bleibt.
          auswahlAendern(container, true);
        });
      }
    });

    gesamtstatusPruefen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Das Theme ersetzt bei Mengenänderungen (+/- bzw. Entfernen) den
  // Warenkorb-Bereich per Ajax und meldet das danach über 'cart-update'.
  // Die frisch gerenderten Elemente brauchen dann erneut ihre Listener
  // bzw. Dropdown-Optionen. Event-basiert statt MutationObserver, damit
  // keine Endlosschleife durch eigene DOM-Änderungen entstehen kann.
  if (typeof subscribe === 'function') {
    subscribe('cart-update', function () {
      init();
    });
  }
})();
